@import 'styles/mixins';
@import 'styles/variables';

/* stylelint-disable-next-line css-modules/no-global-scoped-selector */
:root {
  --scrollbar-width: 8px;
}

.container {
  &::-webkit-scrollbar {
    width: var(--scrollbar-width);
  }
  &::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: rgba($grey-30, 0);
  }

  &.scrolling {
    &::-webkit-scrollbar-thumb {
      background-color: rgba($grey-30, 1);
    }
  }
}
